import React, { FC, ReactNode, useEffect, useState } from 'react';

interface ContinuesCardSliderProps {
  children: ReactNode;
  numCards: number;
  cardWidth: number;
  isBackground?: boolean;
  reverse?: boolean;
}

const ContinuesCardSlider: FC<ContinuesCardSliderProps> = ({
  children,
  numCards,
  cardWidth,
  isBackground = false,
  reverse = false,
}) => {
  const slideInterval = reverse ? 4500 : 3000;
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % numCards);
    }, slideInterval);

    setCurrentIndex((prevIndex) => (prevIndex + 1) % numCards);

    return () => clearInterval(interval);
  }, []);

  return (
    <React.Fragment>
      <div
        className={`${
          isBackground ? 'bg-gray-200' : ''
        } w-full py-4 overflow-hidden relative `}
      >
        <div
          className='flex overflow-hidden '
          style={{
            width: `${numCards * cardWidth}px`,
            transform: `translateX(-${currentIndex * cardWidth}px)`,
            transition: `transform ${slideInterval / 1000}s linear`,
          }}
        >
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContinuesCardSlider;
